/* NutriFitt × Symbiote Deadly Nightshade — symbiote goo engine.
   Takeover (Symbiote line pages) + arrival (Deadly Nightshade page). WebGL1, no dependencies. */
(() => {
  if (window.NFGoo) return;
  const FLAG = 'nfdn-takeover';
  const reduced = () => matchMedia('(prefers-reduced-motion: reduce)').matches;
  const ease = {
    in: t => t * t * t,
    out: t => 1 - Math.pow(1 - t, 3),
    inOut: t => (t < .5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2)
  };

  const VS = 'attribute vec2 a;void main(){gl_Position=vec4(a,0.,1.);}';
  const FS = `precision highp float;
uniform vec2 uRes;uniform float uTime,uFlood,uFocusAmt,uN,uPx,uRelief;uniform vec2 uFocus;uniform vec4 uB[14];
float h21(vec2 p){p=fract(p*vec2(123.34,456.21));p+=dot(p,p+45.32);return fract(p.x*p.y);}
float vn(vec2 p){vec2 i=floor(p),f=fract(p);vec2 u=f*f*(3.-2.*f);return mix(mix(h21(i),h21(i+vec2(1.,0.)),u.x),mix(h21(i+vec2(0.,1.)),h21(i+vec2(1.,1.)),u.x),u.y);}
float fbm(vec2 p){float a=.5,s=0.;for(int i=0;i<4;i++){s+=a*vn(p);p=p*2.03+vec2(1.7,9.2);a*=.5;}return s;}
float field(vec2 p){
  float m=min(uRes.x,uRes.y);vec2 c=p/m;float f=0.;
  for(int i=0;i<14;i++){if(float(i)>=uN)break;vec4 b=uB[i];vec2 d=p-b.xy;f+=b.w*b.z*b.z/(dot(d,d)+b.z*2.);}
  vec2 q=p/uRes;float edge=min(min(q.x,1.-q.x)*uRes.x,min(q.y,1.-q.y)*uRes.y)/m;
  float n1=fbm(c*2.4+vec2(0.,-uTime*.11));
  vec2 dir=p-uRes*.5;float rl=length(dir)/m;vec2 dv=dir/max(length(dir),1.);
  float n2=fbm(dv*1.6+vec2(3.1,rl*3.2-uTime*.42))*smoothstep(0.,.25,rl)+.5*(1.-smoothstep(0.,.25,rl));
  float fl=uFlood*.62-edge+(n1-.5)*.28+(n2-.5)*.24;
  float fo=length((p-uFocus)/m);
  float bu=uFocusAmt-fo+(n1-.5)*.24+(n2-.5)*.12;
  float g=max(fl,bu);
  return f+smoothstep(-.11,.05,g)*1.5+max(g,0.)*3.5;
}
float H(float f){return 1.-exp(-max(f-1.,0.)*1.15);}
void main(){
  vec2 p=gl_FragCoord.xy;p.y=uRes.y-p.y;
  float f=field(p);
  if(f<.55){gl_FragColor=vec4(0.);return;}
  float e=1.5*uPx;
  float fx=field(p+vec2(e,0.)),fy=field(p+vec2(0.,e));
  float gm=max(length(vec2(fx-f,fy-f))/e,1e-4);
  float a=clamp((f-1.)/(gm*1.6*uPx)+.5,0.,1.);
  vec2 c=p/min(uRes.x,uRes.y);
  float r0=fbm(c*4.2+vec2(uTime*.16,-uTime*.12));
  float rx=fbm((p+vec2(e,0.))/min(uRes.x,uRes.y)*4.2+vec2(uTime*.16,-uTime*.12));
  float ry=fbm((p+vec2(0.,e))/min(uRes.x,uRes.y)*4.2+vec2(uTime*.16,-uTime*.12));
  float h0=H(f),hx=H(fx),hy=H(fy);
  float k=26./uPx;
  vec3 n=normalize(vec3((h0-hx)*k+(r0-rx)*k*.3*h0,(h0-hy)*k+(r0-ry)*k*.3*h0,1.));
  if(uRelief>0.){vec2 cw=c*1.4+vec2(uTime*.22,-uTime*.17);float w0=fbm(cw),wx=fbm(cw+vec2(.1,0.)),wy=fbm(cw+vec2(0.,.1));n=normalize(n+vec3(w0-wx,w0-wy,0.)*uRelief*8.5*h0);}
  vec3 V=vec3(0.,0.,1.);
  vec3 L1=normalize(vec3(-.55,-.7,.62)),L2=normalize(vec3(.7,.55,.5)),L3=normalize(vec3(.1,-.9,.45));
  float s1=pow(max(dot(reflect(-L1,n),V),0.),80.);
  float s2=pow(max(dot(reflect(-L2,n),V),0.),26.);
  float s3=pow(max(dot(reflect(-L3,n),V),0.),90.)*.5;
  float fr=pow(1.-n.z,2.4);
  float vein=smoothstep(.022,.0,abs(fbm(c*5.+vec2(uTime*.05,r0))-.5))*smoothstep(.08,.35,h0)*(1.-smoothstep(.55,.95,h0))*step(.62,r0);
  vec3 col=vec3(.012,.006,.018)+vec3(.05,.02,.07)*h0*(1.-r0);
  col+=s1*vec3(1.,.95,1.)*1.15+s3*vec3(.85,.8,1.)*.9;
  col+=s2*vec3(1.,.17,.62)*.85;
  col+=fr*vec3(.62,.16,.6)*.5;
  col+=vein*vec3(.75,.1,.5)*.5;
  gl_FragColor=vec4(col*a,a);
}`;

  function makeGL(canvas) {
    const gl = canvas.getContext('webgl', { premultipliedAlpha: true, alpha: true, antialias: false, powerPreference: 'high-performance' });
    if (!gl) return null;
    const sh = (t, s) => { const o = gl.createShader(t); gl.shaderSource(o, s); gl.compileShader(o); if (!gl.getShaderParameter(o, gl.COMPILE_STATUS)) { console.warn('[NFGoo]', gl.getShaderInfoLog(o)); return null; } return o; };
    const vs = sh(gl.VERTEX_SHADER, VS), fs = sh(gl.FRAGMENT_SHADER, FS);
    if (!vs || !fs) return null;
    const pr = gl.createProgram(); gl.attachShader(pr, vs); gl.attachShader(pr, fs); gl.linkProgram(pr);
    if (!gl.getProgramParameter(pr, gl.LINK_STATUS)) return null;
    gl.useProgram(pr);
    const b = gl.createBuffer(); gl.bindBuffer(gl.ARRAY_BUFFER, b);
    gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([-1, -1, 3, -1, -1, 3]), gl.STATIC_DRAW);
    const loc = gl.getAttribLocation(pr, 'a'); gl.enableVertexAttribArray(loc); gl.vertexAttribPointer(loc, 2, gl.FLOAT, false, 0, 0);
    gl.enable(gl.BLEND); gl.blendFunc(gl.ONE, gl.ONE_MINUS_SRC_ALPHA);
    const u = {}; ['uRes', 'uTime', 'uFlood', 'uFocusAmt', 'uN', 'uPx', 'uFocus', 'uB', 'uRelief'].forEach(n => { u[n] = gl.getUniformLocation(pr, n); });
    return { gl, u };
  }

  function eyesMarkup() {
    const eye = (x, y, r, d) => `<g class="nfg-eye" style="--d:${d}ms;transform-origin:${x}px ${y}px"><circle cx="${x}" cy="${y}" r="${r * 1.55}" fill="#ff2fa0" opacity=".16"/><circle cx="${x}" cy="${y}" r="${r}" fill="#ff2fa0"/><circle cx="${x}" cy="${y}" r="${r * .62}" fill="#fff2fb"/><circle class="nfg-pupil" cx="${x}" cy="${y}" r="${r * .27}" fill="#0b0410"/></g>`;
    return `<svg class="nfg-eyes" viewBox="0 0 200 150" aria-hidden="true" focusable="false">${eye(100, 30, 15, 0)}${eye(62, 56, 13, 90)}${eye(138, 56, 13, 140)}${eye(76, 96, 11, 220)}${eye(124, 96, 11, 260)}</svg>`;
  }

  const CSS = `.nfg{position:fixed;inset:0;z-index:2147483600;pointer-events:none}.nfg.is-blocking{pointer-events:auto;cursor:progress}.nfg canvas{position:absolute;inset:0;width:100%;height:100%}
.nfg-face{position:absolute;left:50%;top:46%;width:min(42vw,300px);transform:translate(-50%,-50%);display:grid;justify-items:center;gap:18px;opacity:0;transition:opacity .25s}
.nfg.is-face .nfg-face{opacity:1}.nfg-eyes{width:100%;height:auto;overflow:visible;filter:drop-shadow(0 0 14px rgba(255,47,160,.75)) drop-shadow(0 0 40px rgba(255,47,160,.35))}
.nfg-eye{transform:scaleY(.04);transition:transform .32s cubic-bezier(.2,.9,.2,1.3);transition-delay:var(--d)}.nfg.is-face .nfg-eye{transform:scaleY(1)}.nfg.is-blink .nfg-eye{transform:scaleY(.04);transition-delay:0ms;transition-duration:.16s}
.nfg-pupil{transition:transform .2s}.nfg-word{margin:0;font:900 clamp(15px,2.1vw,22px)/1 'NFR Display','NF Line','NFC Display',Arial Black,Arial,sans-serif;letter-spacing:.34em;text-indent:.34em;color:#ff4fb3;text-transform:uppercase;transform:skewX(-10deg);text-shadow:0 0 18px rgba(255,47,160,.55);white-space:nowrap}
.nfg-word span{display:inline-block;opacity:0;transform:translateY(8px);transition:opacity .2s,transform .3s cubic-bezier(.2,.9,.2,1.2)}.nfg.is-word .nfg-word span{opacity:1;transform:none}
@media (prefers-reduced-motion:reduce){.nfg-eye,.nfg-word span{transition:none}}`;

  function mount(opts) {
    opts = opts || {};
    if (!document.getElementById('nfg-css')) { const st = document.createElement('style'); st.id = 'nfg-css'; st.textContent = CSS; document.head.appendChild(st); }
    const root = document.createElement('div'); root.className = 'nfg'; root.setAttribute('aria-hidden', 'true');
    const canvas = document.createElement('canvas'); root.appendChild(canvas);
    const word = (opts.word || 'IT HAS RISEN').split('').map((ch, i) => `<span style="transition-delay:${i * 28}ms">${ch === ' ' ? '&nbsp;' : ch}</span>`).join('');
    root.insertAdjacentHTML('beforeend', `<div class="nfg-face">${eyesMarkup()}<p class="nfg-word">${word}</p></div>`);
    document.body.appendChild(root);
    const ctx = makeGL(canvas);
    const mobile = matchMedia('(max-width: 760px)').matches;
    const px = Math.min(window.devicePixelRatio || 1, 2) * (mobile ? .55 : .7);
    const state = { flood: opts.flood || 0, focusAmt: 0, focus: [innerWidth / 2, innerHeight / 2], balls: [], t0: performance.now(), raf: 0, dead: false };
    const bArr = new Float32Array(14 * 4);
    function size() { canvas.width = Math.max(2, Math.round(innerWidth * px)); canvas.height = Math.max(2, Math.round(innerHeight * px)); }
    size(); addEventListener('resize', size);
    function frame(now) {
      if (state.dead) return;
      state.raf = requestAnimationFrame(frame);
      const t = (now - state.t0) / 1000;
      if (!ctx) { root.style.background = `rgba(4,2,7,${Math.min(1, Math.max(0, state.flood))})`; return; }
      const { gl, u } = ctx;
      gl.viewport(0, 0, canvas.width, canvas.height);
      gl.clearColor(0, 0, 0, 0); gl.clear(gl.COLOR_BUFFER_BIT);
      const n = Math.min(14, state.balls.length);
      for (let i = 0; i < n; i++) { const b = state.balls[i]; bArr[i * 4] = b.x * px; bArr[i * 4 + 1] = b.y * px; bArr[i * 4 + 2] = b.r * px; bArr[i * 4 + 3] = b.w; }
      gl.uniform2f(u.uRes, canvas.width, canvas.height); gl.uniform1f(u.uTime, t); gl.uniform1f(u.uFlood, state.flood);
      gl.uniform1f(u.uFocusAmt, state.focusAmt); gl.uniform1f(u.uN, n); gl.uniform1f(u.uPx, px);
      gl.uniform2f(u.uFocus, state.focus[0] * px, state.focus[1] * px); gl.uniform4fv(u.uB, bArr);
      gl.drawArrays(gl.TRIANGLES, 0, 3);
    }
    state.raf = requestAnimationFrame(frame);
    function tween(key, to, dur, fn, onStep) {
      const from = state[key], s = performance.now();
      return new Promise(res => { const step = now => { if (state.dead) return res(); const k = Math.min(1, (now - s) / dur); state[key] = from + (to - from) * (fn || ease.inOut)(k); if (onStep) onStep(k); if (k < 1) requestAnimationFrame(step); else res(); }; requestAnimationFrame(step); });
    }
    let look = null;
    function track(e) { root.querySelectorAll('.nfg-pupil').forEach(p => { const r = p.ownerSVGElement.getBoundingClientRect(); const dx = Math.max(-1, Math.min(1, (e.clientX - (r.left + r.width / 2)) / (r.width * 1.5))); const dy = Math.max(-1, Math.min(1, (e.clientY - (r.top + r.height / 2)) / (r.height * 1.5))); p.style.transform = `translate(${dx * 3.2}px,${dy * 2.6}px)`; }); }
    addEventListener('pointermove', look = track, { passive: true });
    return {
      root, state, tween, ease, ok: !!ctx,
      face(on) { root.classList.toggle('is-face', on); },
      word(on) { root.classList.toggle('is-word', on); },
      blink() { root.classList.add('is-blink'); setTimeout(() => root.classList.remove('is-blink'), 170); },
      block(on) { root.classList.toggle('is-blocking', on); },
      destroy() { state.dead = true; cancelAnimationFrame(state.raf); removeEventListener('resize', size); removeEventListener('pointermove', look); root.remove(); }
    };
  }

  function spawnBalls(state, focusRect) {
    const W = innerWidth, H = innerHeight, m = Math.min(W, H), balls = [];
    const n = focusRect ? 3 : 4;
    for (let i = 0; i < n; i++) {
      const side = (i + Math.floor(Math.random() * 4)) % 4, k = .2 + Math.random() * .6;
      const ox = side === 0 ? k * W : side === 1 ? W + 10 : side === 2 ? k * W : -10;
      const oy = side === 0 ? -10 : side === 1 ? k * H : side === 2 ? H + 10 : k * H;
      const reach = .3 + Math.random() * .16;
      const tx = ox + (W * (.3 + Math.random() * .4) - ox) * reach * 1.6, ty = oy + (H * (.3 + Math.random() * .4) - oy) * reach * 1.6;
      const r = m * (.048 + Math.random() * .02), bend = (Math.random() - .5) * m * .25, sp = .7 + Math.random() * .45;
      [[.14, 1.3], [.38, 1.05], [.62, .88], [.86, .72]].forEach(([f, rr]) => balls.push({ tendril: true, ox, oy, tx, ty, f, bend, sp, x: ox, y: oy, r: 0, gr: r * rr, w: 1 }));
    }
    if (focusRect) {
      const cx = focusRect.left + focusRect.width / 2, cy = focusRect.top + focusRect.height / 2;
      const r = Math.min(focusRect.width, focusRect.height);
      balls.push({ x: cx, y: cy, r: 0, gr: r * .2, w: 1, tx: cx, ty: cy, sp: 1 });
      balls.push({ x: cx - r * .1, y: cy + r * .2, r: 0, gr: r * .14, w: 1, tx: cx - r * .25, ty: cy + r * .35, sp: .8 });
    }
    state.balls = balls.slice(0, 14);
  }
  function stepBalls(state, k) {
    state.balls.forEach(b => {
      const kk = ease.out(Math.min(1, k * b.sp));
      if (b.tendril) {
        const f = b.f * kk, nx = -(b.ty - b.oy), ny = b.tx - b.ox, nl = Math.hypot(nx, ny) || 1;
        const sway = Math.sin(f * Math.PI) * b.bend;
        b.x = b.ox + (b.tx - b.ox) * f + nx / nl * sway;
        b.y = b.oy + (b.ty - b.oy) * f + ny / nl * sway;
        b.r = b.gr * (.55 + .45 * Math.min(1, kk * 1.6));
      } else {
        b.cx = b.cx ?? b.x; b.cy = b.cy ?? b.y;
        b.x = b.cx + (b.tx - b.cx) * kk; b.y = b.cy + (b.ty - b.cy) * kk; b.r = b.gr * kk;
      }
    });
  }

  /* Symbiote line page: wait 1.5 s, swallow the page, land on Deadly Nightshade. */
  function takeover(cfg) {
    if (!cfg || !cfg.url || (window.__nfdnTook && !cfg.force)) return;
    window.__nfdnTook = true;
    const nav = performance.getEntriesByType && performance.getEntriesByType('navigation')[0];
    if (!cfg.force && nav && nav.type === 'back_forward') return;
    const go = () => {
      try { sessionStorage.setItem(FLAG, String(Date.now())); } catch (e) {}
      location.assign(cfg.url);
    };
    if (reduced()) { setTimeout(go, cfg.delay || 1500); return; }
    const link = document.createElement('link'); link.rel = 'prefetch'; link.href = cfg.url; document.head.appendChild(link);
    let g = null;
    const start = () => {
      if (document.hidden) { document.addEventListener('visibilitychange', start, { once: true }); return; }
      g = mount({ word: cfg.word });
      g.block(true);
      const el = cfg.focus && document.querySelector(cfg.focus);
      const rect = el && el.getBoundingClientRect();
      const vis = rect && rect.width > 40 && rect.bottom > 0 && rect.top < innerHeight;
      if (vis) g.state.focus = [rect.left + rect.width / 2, rect.top + rect.height / 2];
      spawnBalls(g.state, vis ? rect : null);
      const main = document.querySelector('#content, main') || document.body;
      main.style.transition = 'transform .9s cubic-bezier(.5,0,.75,0), filter .9s';
      requestAnimationFrame(() => { main.style.transform = 'scale(.985)'; main.style.filter = 'saturate(.4) brightness(.6)'; });
      g.tween('focusAmt', vis ? .55 : 0, 1100, ease.in);
      g.tween('flood', 1.32, 1050, ease.in, k => stepBalls(g.state, k)).then(() => { setTimeout(go, 60); });
    };
    setTimeout(start, cfg.delay == null ? 1500 : cfg.delay);
    addEventListener('pageshow', e => { if (e.persisted && g) { g.destroy(); g = null; const main = document.querySelector('#content, main'); if (main) { main.style.transform = ''; main.style.filter = ''; } } });
  }

  /* Deadly Nightshade page: the goo that took the old page now lets go. */
  function arrive(cfg) {
    cfg = cfg || {};
    const html = document.documentElement;
    const done = () => { html.classList.remove('dn-arrive', 'dn-intro'); html.classList.add('dn-revealed'); document.dispatchEvent(new CustomEvent('nfdn:revealed')); };
    if (!html.classList.contains('dn-arrive') && !html.classList.contains('dn-intro')) { done(); return; }
    if (reduced()) { done(); return; }
    const full = html.classList.contains('dn-arrive');
    const g = mount({ flood: 1.4, word: cfg.word });
    if (!g.ok) { g.destroy(); done(); return; }
    g.block(true);
    requestAnimationFrame(() => requestAnimationFrame(() => {
      html.classList.add('dn-arrive--live');
      setTimeout(() => {
        g.block(false);
        document.dispatchEvent(new CustomEvent('nfdn:reveal-start'));
        g.tween('flood', -.35, full ? 900 : 700, ease.inOut).then(() => { g.destroy(); done(); });
      }, 60);
    }));
  }

  window.NFGoo = { mount, takeover, arrive, FLAG, gl: makeGL };
})();
